import { Tooltip } from "antd";
import InfoIcon from "../../assets/InfoIcon";
type PropType = { content: string; customClass?: string; toolTipText?: string };

export default function SectionHeading({ content, customClass, toolTipText }: PropType) {
  return (
    <div className={`flex gap-1.5 items-center mb-2 ${customClass}`}>
      <span className="md:text-[18px] text-[14px] text-hardGrey md:font-semibold font-normal text-center font-poppins text-heading">
        {content}
      </span>
      <Tooltip title={toolTipText}>
        <span><InfoIcon /></span>
      </Tooltip>
    </div>
  );
}
